import { namespace } from '../constants'
import { prop, compose } from 'ramda'

const root = prop(namespace)
// properties selectors
export const data = compose(
  prop('data'),
  root
)
export const total = compose(
  prop('total'),
  root
)
export const propertyName = compose(
  prop('propertyName'),
  data
)
export const city = compose(
  prop('city'),
  data
)
export const state = compose(
  prop('state'),
  data
)
export const propertySearchListLookup = compose(
  prop('propertySearchListLookup'),
  data
)
export const isSearchListLoading = compose(
  prop('isSearchListLoading'),
  data
)


